module.exports = __webpack_public_path__ + "img/woman.9ee19997.png";